export default __webpack_public_path__ + "static/media/br_ad_banner_mobile.a79035a7.jpg";